import { render } from "./ManageNewsBookmark.vue?vue&type=template&id=97d958d2&scoped=true"
import script from "./ManageNewsBookmark.vue?vue&type=script&lang=js"
export * from "./ManageNewsBookmark.vue?vue&type=script&lang=js"

import "./ManageNewsBookmark.vue?vue&type=style&index=0&id=97d958d2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d958d2"]])

export default __exports__